import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { FeatureFlag, useFeatureFlagResolved } from '../services/featureFlag.service';

// Route-level gate on a LaunchDarkly flag. Hiding a nav link is not a gate — the
// URL still loads — so any page whose sidebar entry is flagged needs this too.
//
// Waits for the flag to resolve before redirecting, so a cold direct-URL load
// doesn't bounce the user home before LaunchDarkly has reported in. Same
// reasoning as RuthieGuard, which predates this and stays as-is.
export default function FeatureFlagGuard({
  flag,
  fallback = '/',
  children,
}: PropsWithChildren<{ flag: FeatureFlag; fallback?: string }>) {
  const { value: enabled, isLoading } = useFeatureFlagResolved(flag, false);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!enabled) {
    return <Navigate to={fallback} replace />;
  }

  return <>{children}</>;
}
